"use client";

import { useEffect, useState } from "react";

/** Иконка чемпиона по числовому id (CommunityDragon — без маппинга в имя). */

/** KAN-203: запись аугмента из CDragon-джейсона. */
type RawAugment = {
  id?: number;
  iconLarge?: string;
  iconSmall?: string;
  name?: string;
};
export function getChampionSquareById(championId: number): string {
  if (!championId || championId <= 0) return "/images/champion-placeholder.png";
  return `https://raw.communitydragon.org/latest/plugins/rcp-be-lol-game-data/global/default/v1/champion-icons/${championId}.png`;
}

// ── Аугменты Arena (cdragon/arena/en_us.json) ────────────────────────────────

const ARENA_JSON = "https://raw.communitydragon.org/latest/cdragon/arena/en_us.json";

interface AugmentInfo {
  icon: string;
  name: string;
}

let augCache: Record<number, AugmentInfo> | null = null;
let augPromise: Promise<Record<number, AugmentInfo>> | null = null;

function cdragonAsset(path: string): string {
  // iconLarge вида "ASSETS/UX/CherryAugments/Icons/Xxx.png" → game-asset URL (lowercase).
  const clean = path.replace(/^\/+/, "").toLowerCase();
  return `https://raw.communitydragon.org/latest/game/${clean}`;
}

export function loadArenaAugments(): Promise<Record<number, AugmentInfo>> {
  if (augCache) return Promise.resolve(augCache);
  if (augPromise) return augPromise;
  augPromise = fetch(ARENA_JSON)
    .then((r) => r.json())
    .then((j: { augments?: RawAugment[] }) => {
      const map: Record<number, AugmentInfo> = {};
      for (const a of j?.augments ?? []) {
        const id = a?.id;
        const icon = a?.iconLarge || a?.iconSmall;
        if (typeof id === "number" && icon) {
          map[id] = { icon: cdragonAsset(String(icon)), name: a?.name ?? "" };
        }
      }
      augCache = map;
      return map;
    })
    .catch(() => ({}) as Record<number, AugmentInfo>);
  return augPromise;
}

/** Хук: карта id→аугмент (иконка+имя). Грузится один раз, кэшируется. */
export function useArenaAugments(): Record<number, AugmentInfo> {
  const [map, setMap] = useState<Record<number, AugmentInfo>>(augCache ?? {});
  useEffect(() => {
    let active = true;
    loadArenaAugments().then((m) => {
      if (active) setMap(m);
    });
    return () => {
      active = false;
    };
  }, []);
  return map;
}
